<div class="mt-2">
    <app-search-google-maps *ngIf="allowSearch" (placeChanged)="OnSelectFromSearch($event)"></app-search-google-maps>
    <div style="height:300px; width:100%;max-width:550px;overflow: hidden;">
        <google-map width="100%" height="100%" id="customMap15" [center]="MapCenter" [zoom]="MapZoom"
            [options]="mapOptions" (mapClick)=" canPick ?pickMap($event) : null">
            <map-marker *ngIf="marker" [options]="marker"></map-marker>
            <!-- <map-info-window *ngIf="lable" [options]="MapInfo"></map-info-window> -->
        </google-map>
    </div>
    <p *ngIf="isRequired" class="has-error mt-2">{{"form_message.Required"|translate}}</p>
</div>